import { useEffect } from "react";
import { useRedux } from "./index";
import { fetchWorkflows } from "../redux/process/actions";
import { POLLING_INTERVAL } from "../constants/process";

export const useWorkflowData = () => {
  const { dispatch } = useRedux();

  useEffect(() => {
    // Initial fetch
    dispatch(fetchWorkflows());

    const intervalId = setInterval(() => {
      // Check if the document is visible to avoid polling in background tabs
      if (document.visibilityState === "visible") {
        dispatch(fetchWorkflows());
      }
    }, POLLING_INTERVAL);

    return () => {
      clearInterval(intervalId); // Cleanup on unmount
    };
  }, [dispatch]);
};
